import RefreshData from '../RefreshData';
import RsvpService from '../RsvpService';
import RSVP_CONSTS from '../../constants';
var moment = require('moment');

const itemShouldBeRefreshed       = (item) => item && moment.utc() > item.start_datetime_utc - (item.checkin_start || 0) * 60;
const attendanceShouldBeRefreshed = (attendance) => attendance && [RSVP_CONSTS.ATTENDANCE.STATUS_REGISTERED, RSVP_CONSTS.ATTENDANCE.STATUS_CHECKINAFTER].indexOf(attendance.status) !== -1;
const itemNeedsRefreshed          = (item, attendance) => itemShouldBeRefreshed(item) && attendanceShouldBeRefreshed(attendance);

// Check if event/session self checkin has already started
const checkIfDataNeedsRefreshed = (data) => {
    if (!data) return [];
    
    const filterFn = (item) => {
        const attendance = data.attendances.find(a => a.event_id === (item || {}).id);
        return !(item || {}).checkin_started && attendanceShouldBeRefreshed(attendance);
    }
    const mapFn = (item) => (item || {}).id;

    return [data.event].concat(data.sessions.map(s => s.time)).filter(filterFn).map(mapFn);
}

// Check if event/session has passed checkin time
const checkIfDataNeedsRefreshedByDate = (data) => {
    if (!data) return [];
    
    const filterFn = (item) => {
        const attendance = data.attendances.find(a => a.event_id === (item || {}).id);
        if (attendance && itemNeedsRefreshed(item, attendance)) return item;
    };
    const mapFn = (item) => item.id;

    return [data.event].concat(data.sessions.map(s => s.time)).filter(filterFn).map(mapFn);
}

let interval;

export const SelfCheckinRefreshInterval = (data) => {
    // Only run for ONLINE events
    if (!(data && (RsvpService.isOnline(data.event) || RsvpService.isHybrid(data.event)))) return;

    // Clear interval if already set
    if (interval) clearInterval(interval);

    const time = 1000 * 60;
    const fn   = () => {
        if (checkIfDataNeedsRefreshedByDate(data).length) {
            RefreshData().then(res => {
                data = res;
                if (!checkIfDataNeedsRefreshed(data).length) clearInterval(interval);
            })
        } else {
            // Clear interval
            clearInterval(interval);
        }
    };
    interval = setInterval(fn, time);
}

export default SelfCheckinRefreshInterval;